export const EXPORT_FILING_OPTIONS = [
  { value: '', label: 'Select One' },
  { value: 'ITN', label: 'ITN - International Transaction Number' },
  { value: 'FTR', label: 'FTR - Foreign Trade Regulations exemption' },
  { value: 'EEI', label: 'EEI - DHL as EEI filing agent' },
]

export const DUTY_TAX_OPTIONS = [
  { value: '', label: 'Select One' },
  { value: 'Shipper', label: 'Shipper' },
  { value: 'Receiver', label: 'Receiver' },
]

// FTR Exemption Codes from DHL AES Codes list
export const FTR_EXEMPTION_CODES = [
  { code: 'NO_EEI_30_36', description: 'No EEI required per 30.36' },
  { code: 'NO_EEI_30_37_a', description: 'No EEI required, single commodity valued under $2,500' },
  { code: 'NO_EEI_30_37_b', description: 'No EEI required, Tools of trade' },
  { code: 'NO_EEI_30_37_c', description: 'No EEI required, Diplomatic pouches or their contents' },
  { code: 'NO_EEI_30_37_d', description: 'No EEI required, Human remains' },
  { code: 'NO_EEI_30_37_e', description: 'No EEI required, Shipments to Canada' },
  { code: 'NO_EEI_30_37_f', description: 'No EEI required, Gift parcels & humanitarian donations' },
  { code: 'NO_EEI_30_37_g', description: 'No EEI required, Diplomatic pouches' },
  { code: 'NO_EEI_30_37_h', description: 'No EEI required, Exports to US territories' },
  { code: 'NO_EEI_30_37_i', description: 'No EEI required, Items temporarily exported and returned' },
  { code: 'NO_EEI_30_37_j', description: 'No EEI required, Baggage and household effects' },
  { code: 'NO_EEI_30_37_k', description: 'No EEI required, Aircraft parts for repair' },
  { code: 'NO_EEI_30_37_o', description: 'No EEI required, Technology/software under EAR' },
  { code: 'NO_EEI_30_37_p', description: 'No EEI required, Conveyances' },
  { code: 'NO_EEI_30_37_q', description: 'No EEI required, Country Group E:1' },
  { code: 'NO_EEI_30_37_r', description: 'No EEI required, Pencarriers' },
  { code: 'NO_EEI_30_37_s', description: 'No EEI required, Crew purchases' },
  { code: 'NO_EEI_30_37_t', description: 'No EEI required, Shipments under $2,500 to Canada' },
  { code: 'NO_EEI_30_37_u', description: 'No EEI required, Gift parcels (personal)' },
  { code: 'NO_EEI_30_37_x', description: 'No EEI required, US Armed Forces' },
  { code: 'NO_EEI_30_37_y', description: 'No EEI required, Information/software subject to EAR' },
  { code: 'NO_EEI_30_39', description: 'Special exemption - 30.39' },
  { code: 'NO_EEI_30_40', description: 'Special exemption - 30.40 (Department of State)' },
]
